module.exports = __webpack_public_path__ + "img/su.94948aaa.svg";